<template>
  <FieldSet :columns="3">
    <template #1>
      <FormKit
        label="Document Date"
        name="documentDate"
        type="datepicker"
        validation="has_no_validation"
        :sequence="['day']"
        :format="appSettings.datepickerFormatDay"
        :value-format="appSettings.datepickerDayValueFormat"
      />
    </template>
    <template #2>
      <FormKit
        label="Received Date"
        name="receivedDate"
        type="datepicker"
        validation="has_no_validation"
        :sequence="['day']"
        :format="appSettings.datepickerFormatDay"
        :value-format="appSettings.datepickerDayValueFormat"
      />
    </template>
    <template #3>
      <FormKit
        label="Due Date"
        name="dueDate"
        type="datepicker"
        validation="has_no_validation"
        :sequence="['day']"
        :format="appSettings.datepickerFormatDay"
        :value-format="appSettings.datepickerDayValueFormat"
      />
    </template>
  </FieldSet>
  <FieldSet
    v-if="
      currentDocument?.typeMurn === LE.DocumentType.NFALetter ||
      currentDocument?.typeMurn === LE.DocumentType.NFARestrictionsLetter ||
      currentDocument?.typeMurn === LE.DocumentType.FWLetter ||
      currentDocument?.typeMurn === LE.DocumentType.CRNLetter
    "
  >
    <template #1>
      <LookupAutocomplete
        label="Letter Status"
        name="letterStatusMurn"
        groupCode="LetterStatus"
        validation="required"
      ></LookupAutocomplete>
    </template>
    <template #2>
      <FormKit
        label="Status Effective Date"
        name="letterStatusDate"
        type="datepicker"
        validation="required"
        :sequence="['day']"
        :format="appSettings.datepickerFormatDay"
        :value-format="appSettings.datepickerDayValueFormat"
      />
    </template>
  </FieldSet>
</template>

<script lang="ts">
export default defineComponent({
  name: "DocumentEditPageExtension",
});
</script>

<script setup lang="ts" generic="T extends Doc">
import { LE } from "@/constants/enums";
import { useAppSettingsStore } from "@modernary/mui/components/common";
import { useCurrentDocumentInjection, type Doc } from "@modernary/mui/components/document";
import { FieldSet } from "@modernary/mui/components/form";
import { LookupAutocomplete } from "@modernary/mui/components/lookup";
import { defineComponent } from "vue";

const currentDocument = useCurrentDocumentInjection();
const props = defineProps<{ item?: T }>();
const appSettings = useAppSettingsStore();
</script>
